import { TranslateFunction } from 'react-utilities';
import * as Games from '../../../../common/request/types/games';
import * as SecurityQuestions from '../../../../common/request/types/securityQuestions';
import * as Thumbnails from '../../../../common/request/types/thumbnails';
import { ErrorCode } from '../interface';

export const WHICH_GAMES_DAYS_DEFAULT = 7;

// IMPORTANT: Add resource keys to `app.config.ts` as well.
export const getResources = (translate: TranslateFunction) =>
  ({
    Action: {
      Confirm: translate('Action.Confirm'),
      PickN: (count: number) => translate('Action.PickN', { count }),
      PleaseTryAgain: translate('Action.PleaseTryAgain'),
      Reload: translate('Action.Reload'),
      SelectAllThatApply: translate('Action.SelectAllThatApply')
    },
    Description: {
      UnknownChoice: translate('Description.UnknownChoice'),
      VerifyYourIdentity: translate('Description.VerifyYourIdentity'),
      WhichGames: translate('Description.WhichGames', { days: WHICH_GAMES_DAYS_DEFAULT })
    },
    Header: {
      PleaseConfirmYourIdentity: translate('Header.PleaseConfirmYourIdentity')
    },
    Message: {
      Error: {
        Default: translate('Message.Error.Default'),
        MustPickN: translate('Message.Error.MustPickN'),
        SecurityQuestions: {
          SessionInactive: translate('Message.Error.SecurityQuestions.SessionInactive')
        }
      }
    }
  } as const);

export type SecurityQuestionsResources = ReturnType<typeof getResources>;

export const mapChallengeErrorCodeToResource = (
  resources: SecurityQuestionsResources,
  errorCode: ErrorCode
): string => {
  switch (errorCode) {
    case ErrorCode.SESSION_EXPIRED:
      return resources.Message.Error.SecurityQuestions.SessionInactive;
    default:
      return resources.Message.Error.Default;
  }
};

export const mapSecurityQuestionsErrorToResource = (
  resources: SecurityQuestionsResources,
  error: SecurityQuestions.SecurityQuestionsError | null
): string => {
  switch (error) {
    case SecurityQuestions.SecurityQuestionsError.SESSION_INACTIVE:
      return resources.Message.Error.SecurityQuestions.SessionInactive;
    default:
      return resources.Message.Error.Default;
  }
};

export const mapSecurityQuestionsErrorToChallengeErrorCode = (
  error: SecurityQuestions.SecurityQuestionsError | null
): ErrorCode => {
  switch (error) {
    case SecurityQuestions.SecurityQuestionsError.SESSION_INACTIVE:
      return ErrorCode.SESSION_EXPIRED;
    default:
      return ErrorCode.UNKNOWN;
  }
};

export const mapGamesErrorToResource = (
  resources: SecurityQuestionsResources,
  error: Games.GamesError | null
): string => {
  switch (error) {
    default:
      return resources.Message.Error.Default;
  }
};

export const mapThumbnailsErrorToResource = (
  resources: SecurityQuestionsResources,
  error: Thumbnails.ThumbnailsError | null
): string => {
  switch (error) {
    default:
      return resources.Message.Error.Default;
  }
};
